import { useNavigate } from 'react-router-dom';

import { useAuthStore } from '@/features/auth/store/authStore.js';
import { Logo } from '@/shared/components/Logo.js';

export function HeaderBar(): JSX.Element {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const clear = useAuthStore((s) => s.clear);

  const handleLogout = (): void => {
    clear();
    navigate('/login');
  };

  return (
    <header className="sticky top-0 z-20 flex h-16 items-center justify-between gap-4 border-b border-cream-dark/60 bg-cream/80 px-4 backdrop-blur md:px-6 lg:px-10">
      <div className="flex items-center gap-3 lg:hidden">
        <Logo variant="mark" className="h-10 w-10 shrink-0" />
        <span className="font-serif text-lg font-semibold text-brown">Booknest</span>
      </div>

      <div className="ml-auto flex items-center gap-2">
        <button
          type="button"
          aria-label="Notifications"
          className="flex h-10 w-10 items-center justify-center rounded-xl bg-paper text-brown shadow-sm transition-colors hover:bg-cream-dark"
        >
          <span aria-hidden>🔔</span>
        </button>
        <button
          type="button"
          onClick={() => navigate('/profile')}
          aria-label="Aller au profil"
          className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-rose to-terracotta text-sm font-semibold text-cream-light shadow-sm hover:from-terracotta hover:to-terracotta-dark"
        >
          {user?.displayName ? user.displayName.charAt(0).toUpperCase() : '👤'}
        </button>
        <button
          type="button"
          onClick={handleLogout}
          aria-label="Se déconnecter"
          title="Se déconnecter"
          className="flex h-10 w-10 items-center justify-center rounded-xl bg-paper text-brown shadow-sm transition-colors hover:bg-cream-dark"
        >
          <span aria-hidden>🚪</span>
        </button>
      </div>
    </header>
  );
}
